import { ComponentPropsWithoutRef } from 'react'
import { clsx } from '@unbridaled/shared/utils/clsx'

export type ModalFooterProps = ComponentPropsWithoutRef<'div'> & {
  behavior?: 'sticky' | 'block'
}

export const ModalFooter = ({
  children,
  className,
  behavior = 'sticky',
  ...props
}: ModalFooterProps): React.ReactNode => (
  <div
    data-slot="footer"
    className={clsx(
      'uui-flex uui-items-center uui-justify-end',
      'uui-py-4 uui-px-6 uui-space-x-2.5',
      'uui-border-t uui-border-primary uui-bg-white uui-rounded-b-md',
      behavior === 'sticky' ? 'uui-sticky uui-bottom-0 uui-left-0 uui-right-0' : '',
      className
    )}
    {...props}
  >
    {children}
  </div>
)
